// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5a7a5031","59":"58cbf2f1","88":"fffd7570","676":"3ec1e919"}[chunkId] + ".chunk.js";
};